import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { apiKey } from "../../../config/config";
import { toast } from "react-toastify";
import { languageHelper } from "../../../config/helperFunctions";

function MailCongfig() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const [formData, setFormData] = useState({
    'mailer_name': '',
    'driver': '',
    'user': '',
    'password': '',
    'host': '',
    'port': '',
    'protocol': '',
    'status': '',
  })
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    axios.post(`${apiKey}/api/rms/admin/mail-config`, formData, {
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    })
      .then((res) => {
        toast.success(res?.data?.message);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || "Something went wrong");
      });
  }

  useEffect(() => {
    axios.get(`${apiKey}/api/rms/admin/mail-config`, {
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    })
      .then((res) => {
        setFormData(res?.data?.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [user.token]);

  return (
    <main>
      <div className="relative my-16 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg bg-white rounded-lg p-4 border-0">
        <div className="flex justify-between items-center mb-4">
          <h1 className="text-d-bg-text text-2xl ">{languageHelper('Smtp mail config')}</h1>
        </div>
        <div className="w-full">
          <form action="" className="w-full" onSubmit={handleSubmit} >
            <div className="flex flex-col lg:flex-row gap-x-8 gap-y-2 w-full">

              <label htmlFor="" className="w-full lg:w-1/4 ">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  {languageHelper("Email Status")}
                </span>
                <div className="mb-2 pt-0">
                  <input type="radio" name="status" id="Active" value="active" checked={formData.status === "active"} onChange={(e) => setFormData({ ...formData, status: "active" })} />
                  <label className="form-check-label ps-2 pe-3 text-d-bg-text text-sm mb-2 " for="Active">
                    {languageHelper("Active")}
                  </label>
                  <input className="ps-5 form-check-input" type="radio" name="status"
                    id="Inactive" value="inactive" checked={formData.status === "inactive"} onChange={(e) => setFormData({ ...formData, status: "inactive" })} />
                  <label className="form-check-label  ps-2 pe-3 text-d-bg-text text-sm mb-2 " for="Inactive">
                    {languageHelper("Inactive")}
                  </label>
                </div>
              </label>
            </div>


            <div className="flex flex-col lg:flex-row gap-x-8 gap-y-2 w-full pt-3">
              <label htmlFor="" className="w-full lg:w-1/4">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  {languageHelper("Mailer name")}
                </span>
                <div className="mb-2 pt-0">
                  <input type="text" placeholder="Imdady Demo Account"
                    name="mailer_name"
                    value={formData.mailer_name}
                    onChange={handleChange}
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                  />
                </div>
              </label>


              <label htmlFor="" className="w-full lg:w-1/4">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  {languageHelper("Driver")}
                </span>
                <div className="mb-2 pt-0">
                  <input type="text" placeholder="SMTP"
                    name="driver"
                    value={formData.driver}
                    onChange={handleChange}
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                  />
                </div>
              </label>

              <label htmlFor="" className="w-full lg:w-1/4">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  {languageHelper("User")}
                </span>
                <div className="mb-2 pt-0">
                  <input type="text" placeholder="info@imdadyrms.com"
                    name="user"
                    value={formData.user}
                    onChange={handleChange}
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                  />
                </div>
              </label>
            </div>

            <div className="flex flex-col lg:flex-row gap-x-8 gap-y-2 w-full pt-3">
              <label htmlFor="" className="w-full lg:w-1/4">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  {languageHelper("Password")}
                </span>
                <div className="mb-2 pt-0">
                  <input type="text" placeholder="*********"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                  />
                </div>
              </label>


              <label htmlFor="" className="w-full lg:w-1/4">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  {languageHelper("Host")}
                </span>
                <div className="mb-2 pt-0">
                  <input type="text" placeholder="mail.imdadyrms.com"
                    name="host"
                    value={formData.host}
                    onChange={handleChange}
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                  />
                </div>
              </label>

              <label htmlFor="" className="w-full lg:w-1/4">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  {languageHelper("Port")}
                </span>
                <div className="mb-2 pt-0">
                  <input type="text" placeholder="456"
                    name="port"
                    value={formData.port}
                    onChange={handleChange}
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                  />
                </div>
              </label>
            </div>
            <div className="flex flex-col lg:flex-row gap-x-8 gap-y-2 w-full pt-3">
              <label htmlFor="" className="w-full lg:w-1/4">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  {languageHelper("Protocol")}
                </span>
                <div className="mb-2 pt-0">
                  <input type="text" placeholder="SSL"
                    name="protocol"
                    value={formData.protocol}
                    onChange={handleChange}
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                  />
                </div>
              </label>
            </div>
            <span className="w-full bg-d-bg h-1 my-2 inline-block"></span>
            <div className="flex gap-2">
              <button
                className="bg-d-cat-btn text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
                type="submit"
              >
                {languageHelper("Submit")}
              </button>
              <button
                className="bg-d-cat-btn text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
                type="button"
                onClick={() => navigate(-1)}
              >
                {languageHelper("Back")}
              </button>
            </div>
          </form>
        </div>
      </div>
    </main>
  );
}

export default MailCongfig;